import swal from "sweetalert2";
import store from "@/store";
import { URL } from "@/utils/api";

export default async ({ from, next, router, to }) => {
  await store
    .dispatch("user/checkLogin")
    .then(next)
    .catch((error) => {
      //console.log("middleware");
      if (error) {
        swal({
          type: "error",
          title: "Səhv",
          text: error,
        }).then(() => {
          return (window.location.href =
            URL[process.env.NODE_ENV].auth_exec_page_origin);
        });
      } else {
        return (window.location.href =
          URL[process.env.NODE_ENV].auth_exec_page_origin);
      }
    });
};
